import CookieSettingsButton from './partials/CookieSettingsButton';
import Container from '~/grid/Container';

/**
 * @param {SpecialElementProps} props
 */
const SpecialElement = ({ value }) => {
  let element = <></>;
  switch (value) {
    case 'ONETRUST_COOKIE_LIST':
      element = <div id="ot-sdk-cookie-policy"></div>;
      break;
    case 'COOKIE_SETTINGS_CTA':
      element = <CookieSettingsButton />;
      break;
    default:
      break;
  }
  return <Container>{element}</Container>;
};

export default SpecialElement;
